module.exports = __webpack_public_path__ + "static/media/fa-solid-900.2d0415fa.woff";